import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import SparkSvg from "../../../../../assets/Spark.svg";
import { Button } from "@mui/material";
import "./SparkArrival.css"
import { setOpenModal } from "../../../store/controlPanelSlice";
export default function SparkArrival({ onClose }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();


    const cancel = () => {
        onClose();
    };
    const OpenSendSparkModal = () => {
        onClose();
        dispatch(setOpenModal("SendSparks"));
    };

    return (
        <>
            {(

                <div className="Spark-Modal" onClick={cancel}>
                    <div className="Spark-modal-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="Spark-Modal-header">
                            <div className="Spark-Modal-header-left">
                                <img src={SparkSvg} className="Spark-header" />

                                <div className="Spark-Modal-header-title">
                                    <span className="Spark-Modal-header-title-text">
                                        {t("sparks_arrived")}
                                    </span>
                                    <span className="Spark-modal-header-subtitle">
                                        {t("daily_donation")}
                                    </span>
                                </div>
                            </div>
                            <div className="Spark-modal-header-right">
                                <Button className="close-button" onClick={cancel}
                                    style={{ padding: "0", margin: "0", maxWidth: "30px", width: "30px", minWidth: "20px" }}>
                                    <span className="material-symbols-outlined">close</span>
                                </Button>
                            </div>
                        </div>
                        <div className="Spark-modal-content" >
                            <div className="all-sparks" >
                                <div className="Spark-icons">
                                    {Array.from({ length: 6 }, (_, index) => (
                                        <img
                                            key={index}
                                            src={SparkSvg}
                                            className="Spark-icon"
                                            alt="spark icon"
                                        />
                                    ))}
                                </div>
                                <span className="Spark-numbers">
                                    +6
                                </span>
                            </div>
                            <div className="Spark-Text">
                                <span className="reset-text">
                                    {t("sparks_expire")}
                                </span>
                            </div>
                        </div>
                        <div className="Spark-modal-button-container">
                            <button type="button" className="Spark-modal-button-cancel" onClick={cancel}>
                                {t("later")}
                            </button>
                              <button type="button" className="Spark-modal-button-send-sparks" onClick={OpenSendSparkModal}>
                                {t("distibute_now")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}